function next_Collection() {
  var next_collection = $('.collection-navigation li.active').next('li').find('.navfirsttitle').text();
  var next_collection_url = $('.collection-navigation li.active').next('li').find('a').attr('href');
  $('.defualt-next-collection .next-collection-url').attr('href', next_collection_url);
  $('.defualt-next-collection .next-collection-title').text(next_collection);
  if (next_collection_url == undefined) {
    $('.defualt-next-collection').hide();
  }
}
next_Collection();

var advance = function advance() {
  $(".grid-meta").matchHeight({property:"height"});
  $(".top_content").matchHeight({property:"height"});
}

window.addEventListener('DOMContentLoaded',function () {
  $(".grid-meta").matchHeight({property:"height"});
  $(".top_content").matchHeight({property:"height"});
});

window.infinitescroll = {
  scolljs: function () {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: '',
      callback: function() {
        advance();
        updateProductCardsWithColorVariantDataOnHover();
      },
      offset: 1000
    });
  }
}

function updateProductCardsWithColorVariantDataOnHover(container = document) {
  const productItems = container.querySelectorAll('.product-item');
  productItems.forEach(product => {
    const colorLinks = product.querySelectorAll('.grid-colorlist li');
    const activeImage = product.querySelector('.normal-img .product-link');
    const productTitle = product.querySelector('.top_content h5 a');
    const titleContainer = product.querySelector('.top_content h5');
    const productPrice = product.querySelector('.bottom_content .normal-price');
    const comparePriceElement = product.querySelector('.bottom_content .compare-price .money');
    const hiddenVariantImages = product.querySelectorAll('.hidden-variant-images .variant-image-container');
    const quickshopContainer = product.querySelector('.var_div');
    const quickViewButtonWrapper = product.querySelector('.quickviewbtn-wrapper');
    const quickviewBtn = quickshopContainer.querySelector('.quickviewbtn');
    const sizeGrid = quickshopContainer.querySelector('.size_grid');

    // Store the original values
    const originalTitle = productTitle.textContent;
    const originalPrice = productPrice.textContent;
    const originalComparePrice = comparePriceElement ? comparePriceElement.textContent : '';
    const originalQuickviewBtnTitle = quickviewBtn.getAttribute('data-title');
    const originalQuickviewBtn = quickViewButtonWrapper.innerHTML;
    let originalSizeGrid = '';
    if (sizeGrid) {
      originalSizeGrid = sizeGrid.innerHTML;
    }

    if (colorLinks) {
      colorLinks.forEach(link => {
        const handle = link.querySelector('a').getAttribute('data-handle');
        const linkElement = link.querySelector('a');
        linkElement.dataset.initialBorder = linkElement.style.border;
        const spanElement = linkElement.querySelector('span');
        const collectionTitle = link.querySelector('a').getAttribute('data-collection-title');
        let variantImage = null;
        if (hiddenVariantImages.length > 0) {
          variantImage = Array.from(hiddenVariantImages).find(div => div.getAttribute('data-product-handle') === handle);
        }
        let productData = null;

        const fetchData = () => {
          if (!productData) {
            fetch('/products/' + handle + '.js')
              .then(response => response.json())
              .then(data => {
                productData = data;
                // console.log('Product data fetched successfully.', productData);
                updateProductData();
              })
              .catch(error => {
                console.error('An error occurred while fetching the product data.', error);
              });
          } else {
            updateProductData();
          }
        };

        const updateProductData = () => {

          const newTitle = productData.title;
          const newPrice = productData.price;
          const newComparePrice = productData.compare_at_price;
          const newVariants = productData.variants;

          if (newTitle && newPrice) {
            productTitle.textContent = newTitle;
            productPrice.textContent = `£${(newPrice / 100).toFixed(2)}`;
            
            titleContainer.style.overflowX = 'hidden';
            titleContainer.style.whiteSpace = 'nowrap';
            titleContainer.style.textOverflow = 'ellipsis';

            if (comparePriceElement) {
              if (newComparePrice && newComparePrice !== newPrice) {
                comparePriceElement.textContent = `£${(newComparePrice / 100).toFixed(2)}`;
                comparePriceElement.parentElement.style.display = 'inline';
                productPrice.parentElement.style.color = ''; // Reset to default color
              } else if (newComparePrice && !comparePriceElement.textContent) {
                comparePriceElement.textContent = `£${(newComparePrice / 100).toFixed(2)}`;
                comparePriceElement.parentElement.style.display = 'inline';
                productPrice.parentElement.style.color = ''; // Reset to default color
              } else {
                comparePriceElement.parentElement.style.display = 'none';
                productPrice.parentElement.style.color = '#8B8B8B';
              }
            }

            if (window.innerWidth < 991) {
              // Update size grid on mobile devices
              sizeGrid.innerHTML = newVariants.map(variant => `
                <li data-id="${variant.id}">
                  <a href="javascript:void(0)" class="${variant.available ? 'available' : 'unavailable'}">
                    ${variant.title}
                  </a>
                </li>
              `).join('');
            }
          }
        };

        if (window.innerWidth < 991) {
          // Add click listener for desktop and mobile devices
          link.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior
            
            const currentActive = product.querySelector('.variant-image-container.active');
            if (currentActive) {
              currentActive.classList.remove('active');
            }

            // Reset borders for all color links
            colorLinks.forEach(function(colorLink) {
              const linkElement = colorLink.querySelector('a');
              linkElement.style.border = '1px solid transparent'; // Set border to transparent
            });

            const linkHref = link.querySelector('a').getAttribute('href');
            const firstLinkHref = colorLinks[0].querySelector('a').getAttribute('href');

            if (linkHref === firstLinkHref) { // Check if the clicked link is the first one
            // activeImage.style.display = 'flex';
            if (variantImage) {
              variantImage.classList.remove('active');
            }
            // Restore original quickview button and size grid
              // quickviewBtn.setAttribute('data-handle', handle);
              // quickviewBtn.setAttribute('data-title', originalQuickviewBtnTitle);

              quickViewButtonWrapper.innerHTML = originalQuickviewBtn;

              sizeGrid.innerHTML = originalSizeGrid;
            } else {
              if (variantImage) {
                variantImage.classList.add('active');
              }
            }
            
            // Update quickview button
            // quickviewBtn.setAttribute('data-handle', handle);
            // quickviewBtn.setAttribute('data-title', collectionTitle);
            fetchData();

            quickViewButtonWrapper.innerHTML = `
            <a href="#" class="quickviewbtn" data-handle="${handle}" data-title="${collectionTitle}">
              <span class="d-none d-lg-block">Quick view</span>
              <span class="d-block d-lg-none">
                <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.75" y="5.34314" width="18.2598" height="17.3616" rx="2.25" stroke="white" stroke-width="1.5"/>
                  <path d="M15.2688 4.59269V4C15.2688 2.34314 13.9257 1 12.2688 1H7.49078C5.83393 1 4.49078 2.34314 4.49078 4V4.59269" stroke="white" stroke-width="1.5"/>
                </svg>
              </span>
            </a>
          `;

            if (spanElement) {
              const borderColor = spanElement.style.backgroundColor;
              // Check if the background color is white
              if (borderColor === 'rgb(255, 255, 255)' || borderColor === '#ffffff' || borderColor === '#fff' || borderColor === 'white') {
                linkElement.style.border = '1px solid #eee';
              } else {
                linkElement.style.border = `1px solid ${borderColor}`;
              }
            }
          });
        } else {
          link.addEventListener('mouseover', function() {
            if (variantImage) {
              activeImage.style.display = 'none';
              variantImage.classList.add('active');
            }
            quickshopContainer.style.display = 'none';
            fetchData();

            if (spanElement) {
              const borderColor = spanElement.style.backgroundColor;
              // Check if the background color is white
              if (borderColor === 'rgb(255, 255, 255)' || borderColor === '#ffffff' || borderColor === '#fff' || borderColor === 'white') {
                linkElement.style.border = '1px solid #eee';
              } else {
                linkElement.style.border = `1px solid ${borderColor}`;
              }
            }
          });

          link.addEventListener('mouseout', function() {
            // Reset to the original values
            productTitle.textContent = originalTitle;
            productPrice.textContent = originalPrice;
            activeImage.style.display = 'flex';
            if (variantImage) {
              variantImage.classList.remove('active');
              activeImage.style.display = 'flex';
            }
            quickshopContainer.style.display = 'flex';

            titleContainer.style.overflowX = '';
            titleContainer.style.whiteSpace = '';
            titleContainer.style.textOverflow = '';

            if (comparePriceElement) {
              comparePriceElement.textContent = originalComparePrice;
              comparePriceElement.parentElement.style.display = originalComparePrice ? 'inline' : 'none';
              productPrice.parentElement.style.color = '';
            }
            
            const borderColor = spanElement.style.backgroundColor;
            const isFirstLink = link === colorLinks[0];
            // Check if the background color is white and it's not the first link
            if (!isFirstLink && (borderColor === 'rgb(255, 255, 255)' || borderColor === '#ffffff' || borderColor === '#fff' || borderColor === 'white')) {
              linkElement.style.border = '1px solid #fff';
            } else {
              linkElement.style.border = linkElement.dataset.initialBorder || '';
            }
          });
        }
      });
    }
  });
}

function generateSrcset(url) {
  const widths = [352, 832, 1000];
  return widths.map(width => `${url}?width=${width} ${width}w`).join(', ');
}

document.addEventListener('DOMContentLoaded', function() {
  updateProductCardsWithColorVariantDataOnHover();
});

$(document).on('click', '.change-view', function (e) {
  e.preventDefault();
  $('body').toggleClass('active-model');
  var modalvalue = $('body').hasClass('active-model') ? 'No' : 'yes';  
  localStorage.setItem('modelView', modalvalue);
  /*setTimeout(function(){
    $('body').removeClass('sticky-up');
    $('body').addClass('sticky-down');
  },200);  */
});
var modelState = localStorage.getItem("modelView");
if(modelState == 'No'){
  $('body').addClass('active-model');
}
window.infinitescroll.scolljs();
document.addEventListener('wheel', function (e) {
    var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
    sessionStorage.scrollPos = document.documentElement.scrollTop;
    sessionStorage.totalpage = totalpage;
});
$(".grid-meta").matchHeight({property:"height"});
// if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {  	
//     var scrollTop = sessionStorage?.getItem('scrollPos')
//     window.scrollTo(0, 0);
//     scrollManualy(scrollTop);
//     function scrollManualy(scrollTop) {
//     scrollTop = parseInt(scrollTop);
//      const myTimeout = setTimeout(function () {
//               if (window.scrollY < scrollTop && window.scrollY !== (scrollTop - 150)) {
//                     window.scrollTo(0, scrollTop)
//     				window.scrollTo(0, window.scrollY - 150)
//     				clearTimeout(myTimeout);
//     				scrollManualy(scrollTop)	
//               }else{
// 				clearTimeout(myTimeout);
//     		  }
//           }, 1000);
//       }
// }

function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#product-grid").innerHTML;
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);

  var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
  if (ajaxinatePagination) {
    sessionStorage.setItem('ajaxinateHref', ajaxinatePagination.href);
    sessionStorage.setItem('ajaxinatePage', ajaxinatePagination.dataset.page);
  }
}

function restoreState() {
  if (window.location.pathname.includes('/collections')) {
    
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    var ajaxinateHref = sessionStorage.getItem('ajaxinateHref');
    var ajaxinatePage = sessionStorage.getItem('ajaxinatePage');
    console.log(ajaxinateHref, ajaxinatePage);
    
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#product-grid").innerHTML = loadedProducts;
      sessionStorage.removeItem('loadedProducts');
    }
    if (scrollPosition && collectionURL === window.location.href) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    if (ajaxinateHref && ajaxinatePage && collectionURL === window.location.href) {
      var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
      if (ajaxinatePagination) {
        ajaxinatePagination.href = ajaxinateHref;
        ajaxinatePagination.dataset.page = ajaxinatePage;
      }
      sessionStorage.removeItem('ajaxinateHref');
      sessionStorage.removeItem('ajaxinatePage');
    }
  }
}

document.addEventListener('DOMContentLoaded', restoreState);

document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

// Add touchstart event listener for mobile devices
document.addEventListener('touchstart', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});

document.querySelectorAll('.section-header a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    sessionStorage.clear();
  });
  // Add touchstart event listener for mobile devices
  anchor.addEventListener('touchstart', function() {
    sessionStorage.clear();
  });
});

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    restoreState();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const collView = document.querySelector(".coll-view");
  const collectionGrid = document.querySelector(".collection-grid");
  const gridOptions = document.querySelectorAll(".coll-view a");
  if (!collView || !collectionGrid || gridOptions.length === 0) return;
  let savedView = localStorage.getItem("collection_grid") || document.querySelector(".coll-view a.active")?.getAttribute('data-view');
  localStorage.setItem("collection_grid", savedView);
  collectionGrid.setAttribute('data-mb', savedView);
  gridOptions.forEach(grid => {
    grid.classList.toggle('active', grid.getAttribute('data-view') === savedView);
  });
  collView.addEventListener("click", (e) => {
    
    e.preventDefault();
    const productItems = document.querySelectorAll('.product-item');

    // WC code, keeping as fallback
    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach(entry => {
    //     if(entry.isIntersecting){
    //       entry.target.classList.add('in-viewport');
    //     }
    //   });
    // }, { threshold: 0.5 });
    // productItems.forEach(item => observer.observe(item));

    // Get the product closest to the center of the viewport
    const centerY = window.innerHeight / 2;
    let closestProduct = null;
    let closestDistance = Infinity;

    productItems.forEach(item => {
      const rect = item.getBoundingClientRect();
      const distance = Math.abs(rect.top + rect.height / 2 - centerY);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestProduct = item;
      }
    });

    const closestProductId = closestProduct ? closestProduct.getAttribute('data-index') : null;
    
    let activeIndex = [...gridOptions].findIndex(grid => grid.classList.contains('active'));
    let nextIndex = (activeIndex + 1) % gridOptions.length;
    let nextView = gridOptions[nextIndex].getAttribute('data-view');
    gridOptions.forEach(grid => grid.classList.remove("active"));
    gridOptions[nextIndex].classList.add("active");
    localStorage.setItem("collection_grid", nextView);
    collectionGrid.setAttribute("data-mb", nextView);

    // WC code, keeping as fallback
    // if(document.querySelector('.collection-grid[data-mb="2"]')){
    //   const visibleItem = document.querySelectorAll('.product-item.in-viewport')[(document.querySelectorAll('.product-item.in-viewport').length - 1)];
    //   if(visibleItem){
    //     document.documentElement.style.scrollBehavior = 'auto';
    //     visibleItem.scrollIntoView({ block: 'center' });
    //     document.documentElement.style.scrollBehavior = '';
    //   }
    // }

    // Scroll to the product with same data-index when switching grid view
    if (closestProductId) {
      const targetProduct = document.querySelector(`.product-item[data-index="${closestProductId}"]`);
      if (targetProduct) {
        document.documentElement.style.scrollBehavior = 'auto';
        targetProduct.scrollIntoView({ block: 'center' });
        document.documentElement.style.scrollBehavior = '';
      }
    }
  });
});
